angular.module('zc.core')

.directive 'zcDataProcessingAddendum', () ->
  restrict: 'E'
  templateUrl: '/templates/core/views/data_processing_addendum.html'



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/views/data_processing_addendum.coffee